export default __webpack_public_path__ + "static/media/AcesseAgoraBackground.6fa9ebc6.png";